import React from "react";
import styled from "styled-components";
import { Card } from "fiver-react-ui-components";
const StyledCard = styled(Card)`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: ${p => p.theme.borderRadius};
  padding: 1rem;

  @media (min-width: ${props => props.theme.screenWidthXxs}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const Wrapper = ({
  children,
  minHeight
}) => {
  return /*#__PURE__*/React.createElement(StyledCard, {
    minHeight: minHeight
  }, children);
};

export default Wrapper;